import React from "react";

import Card from "../../../components/Card/Card";
import CardBody from "../../../components/Card/CardBody";
import { useFormContext } from "react-hook-form";
import { GridLegacy } from "@mui/material";
import FormAsyncTC from "../../../components/Forms/FormAsyncTC";

function Zones() {
  const { vestigingId } = useFormContext();

  return (
    // <Card>
    //   <CardBody>
    //     <GridContainer>
    //       <GridItem xs={12} md={2}>
    //         {<TranslationWrapper tKey={"tafels.form.menu.label.zoneSelection"} tDefault={"Zone selection"} />}
    //       </GridItem>
    //       <GridItem xs={12} sm={12} md={10}>
    //         <input name="zones" type="hidden" value={JSON.stringify(props.parent.convertTaglistValue("zones"))} />
    //         <TagList
    //           headerText={null}
    //           dropdownText={
    //             <TranslationWrapper tKey={"tafels.form.menu.taglist.zones.dropdownText"} tDefault={"Select a zone"} />
    //           }
    //           selectedText={
    //             <TranslationWrapper tKey={"tafels.form.menu.taglist.zones.selectedText"} tDefault={"Selected zones"} />
    //           }
    //           selectedItems={props.parent.convertTaglistValue("zones")}
    //           onChange={props.parent.handleTagList("zones")}
    //           items={props.parent.state.zones}
    //           singleSelect
    //         />
    //       </GridItem>
    //     </GridContainer>
    //   </CardBody>
    // </Card>
    <div style={{ width: "100%", height: "100%", overflow: "hidden" }}>
      <Card>
        <CardBody style={{ padding: 16 }}>
          <GridLegacy container spacing={1}>
            <FormAsyncTC
              async={{
                url:
                  "core/zones/search?fields=id as value, zoneName as label&per_page=50&sort_field=zoneName&vestiging_id=" +
                  vestigingId,
                searchField: "zoneName",
              }}
              key={"zones" + vestigingId}
              multiple={true}
              name={"zones"}
              tDefault={"Zone selection"}
              tKey={"tafels.form.menu.label.zoneSelection"}
            />
          </GridLegacy>
        </CardBody>
      </Card>
    </div>
  );
}

export default Zones;
